/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Typography2, typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/notification-center';

type Props = {
  unreadCount: number;
  onMarkAllAsRead: () => void;
};

const styles = {
  title: css`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    align-items: center;
  `,
  noPadding: css`
    ${typography2.actionSecondary};
    left: var(--cds-spacing-100);
  `,
  titleText: css`
    padding-bottom: var(--cds-spacing-100);
  `,
};

const NotificationHeader = ({ unreadCount, onMarkAllAsRead }: Props) => (
  <div css={styles.title}>
    <Typography2 variant="subtitleMedium" component="h2" css={unreadCount > 0 ? undefined : styles.titleText}>
      {_t('Notifications')}
    </Typography2>

    {unreadCount > 0 && (
      <Button variant="ghost" onClick={onMarkAllAsRead} css={styles.noPadding} size="small">
        {_t('Mark all as read')}
      </Button>
    )}
  </div>
);

export default NotificationHeader;
